import HighSchoolPreviewBannerContainer from './container'
export default HighSchoolPreviewBannerContainer
